import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { PsBeaconControl, PsBeaconControlGroup, PsBeaconError } from '../shared/BeaconRegister';
import GenericPanel from './GenericPanel';
import { acctSelHeader, InvestmentInfoContent } from './ConsentContent';
import YodleeConsentSection from './YodleeConsentSection';

const InvInfoPanel = ({
    handleChange,
    headerText = acctSelHeader,
    panelNum,
    checkError,
    showYodleeConsent,
    children,
    open,
}) => {
    return (
        <GenericPanel
            headerText={
                <>
                    <span>
                        {panelNum}. {headerText}
                    </span>
                    {checkError?.checkedConfirmation && (
                        <Box>
                            <PsBeaconError id="inv-info-field-error">
                                Please fill in all required fields to continue.
                            </PsBeaconError>
                        </Box>
                    )}
                </>
            }
            id="inv-info-container"
            open={open}>
            <Box
                id="inv-info-panel-container"
                className="beacon-on-light beacon-theme-modern-outlook">
                <Typography
                    id="investment-info-header-paragraph-1"
                    type="body" scale={100} light
                    sx={{ paddingBottom: '32px' }}>
                    <span dangerouslySetInnerHTML={{ __html: InvestmentInfoContent.header }} />
                </Typography>
                <Typography
                    id="investment-info-header-paragraph-2"
                    type="body" scale={100} light
                    sx={{ paddingBottom: '32px' }}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: InvestmentInfoContent.explanation,
                        }}
                    />
                </Typography>
                <Typography
                    id="investment-info-header-paragraph-3"
                    type="body" scale={100} light
                    sx={{ paddingBottom: '32px' }}>
                    {InvestmentInfoContent.note}
                </Typography>
            </Box>
            <Box id="investment-info-container">
                <Box sx={{ paddingBottom: '40px' }}>
                    <Box id="investment-info-background-container">
                        <Box id="investment-info-content" sx={{ padding: '24px' }}>
                            <Typography
                                dangerouslySetInnerHTML={{
                                    __html: InvestmentInfoContent.mutualFundSection[0]
                                        .contentHeader,
                                }}
                                 bold
                                id="investment-info-header-3"
                                sx={{ paddingBottom: '16px' }}
                            />

                            <Typography
                                type="body" loose scale={100} light
                                id={InvestmentInfoContent.mutualFundSection[0].id}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: InvestmentInfoContent.mutualFundSection[0].content,
                                    }}
                                />
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Box id="workplace-retirement-section-container" sx={{ paddingBottom: '40px' }}>
                <Box id="workplace-retirement-background-container">
                    <Box id="workplace-retirement-container" sx={{ padding: '24px' }}>
                        <Typography
                            id="workplace-retirement-header"
                            bold
                            sx={{ paddingBottom: '16px' }}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: InvestmentInfoContent.workplaceTrustSection.header,
                                }}
                            />
                        </Typography>
                        <Typography
                            id="workplace-retirement-disclosure"
                            type="body" loose scale={100} light
                            sx={{ paddingBottom: '40px' }}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: InvestmentInfoContent.workplaceTrustSection.content,
                                }}
                            />
                        </Typography>
                        <Typography
                            id="workplace-retirement-body"
                            type="body" loose scale={100} light
                            sx={{ paddingBottom: '40px' }}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: InvestmentInfoContent.workplaceTrustSection
                                        .prospContentSub,
                                }}
                            />
                        </Typography>
                        <Box
                            id="accounts-checkboxes-content-container"
                            sx={{
                                border: '1px solid #A8AFB5',
                                padding: '24px',
                            }}>
                            <Typography
                                id="workplace-retirement-body-2"
                                type="body" loose scale={100} light
                                sx={{ paddingBottom: '16px' }}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: InvestmentInfoContent.workplaceTrustSection
                                            .prospContentSubSub,
                                    }}
                                />
                            </Typography>

                            <Box id="accounts-checkboxes-form-container" className="b-flow-space">
                                <PsBeaconControlGroup>
                                    <PsBeaconControl inline id="checked-401k-control">
                                        <label
                                            slot="label"
                                            id="agreement401k-label"
                                            htmlFor="agreement401k">
                                            Workplace Retirement Account(s)
                                        </label>
                                        <input
                                            type="checkbox"
                                            name="agreement401k"
                                            id="agreement401k"
                                            onChange={handleChange('checked401k')}
                                        />
                                    </PsBeaconControl>
                                    <PsBeaconControl
                                        inline
                                        style={{ paddingBottom: '24px' }}
                                        id="checked-trust-control">
                                        <input
                                            type="checkbox"
                                            name="checkedTrust"
                                            id="checkedTrust"
                                            onChange={handleChange('checkedTrust')}
                                        />
                                        <label
                                            slot="label"
                                            id="checkedTrust-label"
                                            htmlFor="checkedTrust">
                                            Trust Account(s)
                                        </label>
                                    </PsBeaconControl>
                                </PsBeaconControlGroup>
                                <PsBeaconControlGroup style={{ marginTop: '0px' }}>
                                    <PsBeaconControl inline id="checked-confirmation-control">
                                        <input
                                            required
                                            type="checkbox"
                                            name="checkedConfirmation"
                                            id="checkedConfirmation"
                                            onChange={handleChange('checkedConfirmation')}
                                        />
                                        <label
                                            className="b-font-weight-bold"
                                            slot="label"
                                            id="checkedConfirmation-label"
                                            htmlFor="checkedConfirmation">
                                            {InvestmentInfoContent.checkboxLabel}
                                        </label>
                                        <div slot="error">This field is required.</div>
                                    </PsBeaconControl>
                                </PsBeaconControlGroup>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {showYodleeConsent && (
                <Box sx={{ paddingBottom: '40px' }} id="yodlee-consent-section-container">
                    <Box id="yodlee-consent-background-container">
                        <YodleeConsentSection handleChange={handleChange} idSuffix="panel" />
                    </Box>
                </Box>
            )}
            <Typography
                id="authorization-explanation-2"
                type="body" scale={100} light>
                {InvestmentInfoContent.closingSection}
            </Typography>
            {children}
        </GenericPanel>
    );
};

export default InvInfoPanel;
